import { CaseListService } from "@/services/case/case-list/CaseListService";
import { ICaseListService } from "@/services/case/case-list/ICaseListService";
import { Container } from "inversify";
import { IoCTypes } from "./IoCTypes";

export const bindCaseListService = (container: Container) => {
    container.bind<ICaseListService>(IoCTypes.CaseListService)
        .to(CaseListService)
}